import { Button, Col, DatePicker, Form, InputNumber, message, Row, Select, Spin, Checkbox, Tag } from "antd"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux";
import helper from "../../utils/helper";
import { errorMessage } from "../../utils/commonStringsConsts";
import { OutPutResult } from '@operations/shared';
import moment from "moment";
import { request } from '../../../../shared/src/apis';
import { createExternalPaymentApi, getPaymentCyclesApi, submitExternalPaymentWithEarlySettlmentApi } from "../../utils/apisConsts";
import { stepperMoving } from "../../stores/actions";
import { paymentTypes } from "../../utils/commonInterfaces";
import { useSelector } from "react-redux";
import { useForm } from "antd/lib/form/Form";
import UserSettlementDetails from "../../components/UserSettlementDetails";
import { DownOutlined, LockOutlined } from "@ant-design/icons";
const { Option } = Select;


export default function SubmitEarlyPayment() {
    const userInfo = useSelector((state: any) => state.actionsReducer?.info)
    const [loadingData, setLoadingData] = useState(false)
    const [sendingData, setSendingData] = useState(false)
    const [errorMode, setErrorMode] = useState(false)
    const [paymentCycles, setPaymentCycles] = useState<{ [key: string]: any }>([])
    const [amounts, setAmounts] = useState({
        beforeAmount: 0,
        afterAmount: 0,
    })
    const [amount, setAmount] = useState(0);
    const [selectedPaymentCycle, setSelectedPaymentCycle] = useState<number>(0);
    const [fullEarlySettlement, setFullEarlySettlement] = useState<any>({});
    const dispatch = useDispatch()
    const [form] = useForm()
    const isDiscountApplied = Form.useWatch('isDiscountApplied', form);
    const paymentType = Form.useWatch('paymentType', form);
    const paymentCycleForm = Form.useWatch('paymentCycle', form);
    const selectedInvoiceCycle = Array.isArray(paymentCycles)
        ? paymentCycles?.find((cycle: { paymentCycle: number }) => cycle?.paymentCycle === paymentCycleForm)
        : undefined;


    useEffect(() => {
        setFullEarlySettlement((prev: any) => {
            if (prev?.dueAmountBeforeDiscount == null || prev?.dueAmountAfterDiscount == null) return prev;
            return { ...prev, dueAmount: isDiscountApplied ? prev.dueAmountAfterDiscount : prev.dueAmountBeforeDiscount };
        });
    }, [isDiscountApplied]);

    const getPaymentCycles = async (paymentType: paymentTypes) => {
        setLoadingData(true)
        const params = {
            ...(paymentType === paymentTypes.fullSettlement ? { includePreviousCycles: 2 } : { mostRecent: true }),
            companyID: userInfo?.companyID,
        }
        try {
            const paymentCyclesRes: { [key: string]: any } = await dispatch(request({ url: getPaymentCyclesApi, method: "GET", params: params }))
            if (paymentCyclesRes?.data?.status === 200) {
                setLoadingData(false)
                if (paymentType === paymentTypes.fullSettlement) {
                    setPaymentCycles(paymentCyclesRes?.data?.allPaymentCycles)
                } else {
                    const todayDate = new Date()
                    const payerDate = new Date()
                    payerDate.setDate(userInfo?.actualCutOffDate)
                    if (payerDate <= todayDate) {
                        payerDate.setMonth(payerDate.getMonth() + 1)
                    }
                    const currentCycle = {
                        cutOffCycleDate: payerDate,
                        paymentCycle: Number(paymentCyclesRes?.data?.allPaymentCycles?.paymentCycle) + 1
                    }
                    setPaymentCycles([paymentCyclesRes?.data?.allPaymentCycles, currentCycle])
                }
            } else {
                message.error(paymentCyclesRes?.data?.message)
                setErrorMode(true)
            }
        }
        catch (error: any) {
            setErrorMode(true)
            setLoadingData(false)
        }
    }

    const buildPartialPaymentBody = (values: any) => ({
        userID: userInfo?.userID,
        startEarly: values?.paymentType,
        paymentCycle: values?.paymentCycle,
        amount: values?.amount,
        collectionDate: moment(values?.collectionDate).format("YYYY-MM-DD")
    });


    const buildFullSettlementBody = (values: any) => ({
        userID: userInfo?.userID,
        externalpaymentAmount: values?.amount,
        collectionDate: moment(values?.collectionDate).format("YYYY-MM-DD"),
        applyDiscount: values?.isDiscountApplied ?? false,
        paymentCycle: values?.paymentCycle
    });


    const paymentHandlers = {
        [paymentTypes.partialSettlement]: {
            api: createExternalPaymentApi,
            buildBody: buildPartialPaymentBody
        },
        [paymentTypes.fullSettlement]: {
            api: submitExternalPaymentWithEarlySettlmentApi,
            buildBody: buildFullSettlementBody
        }
    };

    const createEarlyPayment = async (values: any) => {
        const handler = paymentHandlers[values?.paymentType as keyof typeof paymentHandlers];
        if (!handler) {
            message.error("Unsupported payment type");
            return;
        }
        if (values?.paymentType !== paymentTypes.partialSettlement) {
            if (values?.isDiscountApplied) {
                if (values?.amount < fullEarlySettlement?.dueAmount - fullEarlySettlement?.totalEarlySettlementDiscount) {
                    message.error("External payment amount should be greater than or equal due amount.")
                    return;
                }
            } else {

                if (values?.amount < fullEarlySettlement?.dueAmount) {
                    message.error("External payment amount should be greater than or equal due amount.")
                    return;
                }
            }
        }

        try {
            setSendingData(true);

            const requestData = handler.buildBody(values);

            const response: { [key: string]: any } = await dispatch(
                request({
                    url: handler.api,
                    method: "POST",
                    data: requestData
                })
            );

            const { status, message: msg } = response?.data;
            if (status === 200) {
                message.success(msg);
                dispatch(stepperMoving(0));
            } else {
                message.error(status === 500 ? errorMessage : msg);
            }
        } catch (error: any) {
            message.error(error?.response?.data?.status === 500 ? errorMessage : error?.response?.data?.message);
        } finally {
            setSendingData(false);
        }
    };

    const onAmountChange = (newAmount: number | null) => {
        const normalizedAmount = newAmount ?? 0;
        const updatedAfterAmount = Number(((amounts?.afterAmount ?? 0) + ((amount ?? 0) - normalizedAmount)));
        setAmounts({
            ...amounts,
            afterAmount: updatedAfterAmount
        });
        setAmount(normalizedAmount);

    }
    const handleSelectInvoiceMonth = (cycle: number) => {
        setSelectedPaymentCycle(cycle);
    }

    const paymentTypeChange = (value: number) => {
        form.resetFields(['paymentCycle']);
        setSelectedPaymentCycle(0);
        getPaymentCycles(value)
    }

    return (
        errorMode ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage ? errorMessage : 'Something went wrong, please refresh the page and try again'}
            btnTitle={'Refresh the page'} btnClick={helper.refreshPage} /> :
            <div className="createEarlyPayment">
                <Spin size="large" spinning={loadingData}>
                    <Form name="nest-messages" onFinish={createEarlyPayment} form={form}>
                        <Row className="inputsRow">
                            <Col span={8}>
                                <label>Amount <span>*</span></label>
                                <Form.Item
                                    name="amount"
                                    rules={[{ required: true, message: 'Required' }, { type: "number", min: 1 }]}
                                >
                                    <InputNumber placeholder="Enter Amount" onChange={onAmountChange} />
                                </Form.Item>
                            </Col>
                            <Col span='8'>
                                <label>Payment types <span>*</span></label>
                                <Form.Item
                                    name="paymentType"
                                    rules={[{ required: true, message: 'Required' }]}
                                >
                                    <Select placeholder="Select an payment type" onChange={paymentTypeChange}>
                                        <Option value={1}>Partial Settlement</Option>
                                        <Option value={0}>Full Settlement</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <label>Invoice Month <span>*</span></label>
                                <Form.Item
                                    name="paymentCycle"
                                    rules={[{ required: true, message: 'Required' }]}
                                >
                                    <Select
                                        className={selectedInvoiceCycle?.isLocked ? "invoiceMonthSelect isLocked" : "invoiceMonthSelect"}
                                        placeholder="Select a month"
                                        onChange={handleSelectInvoiceMonth}
                                        disabled={paymentType == null}
                                        optionLabelProp="label"
                                        dropdownClassName="invoiceMonthDropdown"
                                        suffixIcon={selectedInvoiceCycle?.isLocked ? (
                                            <span className="invoiceMonthSuffix">
                                                <Tag icon={<LockOutlined />} color="error">Locked</Tag>
                                                <DownOutlined />
                                            </span>
                                        ) : undefined}
                                    >
                                        {Array.isArray(paymentCycles) &&
                                            paymentCycles?.map((paymentCycle: { id: number, paymentCycle: number, cutOffCycleDate: string, isLocked: boolean }) => {
                                                const formattedDate = moment(paymentCycle?.cutOffCycleDate).format('Do MMM, YYYY');
                                                return (
                                                    <Option key={paymentCycle?.id} value={paymentCycle?.paymentCycle} label={formattedDate} disabled={paymentCycle?.isLocked && paymentType === paymentTypes.partialSettlement}>
                                                        <div className="invoiceMonthOption">
                                                            <span>{formattedDate}</span>
                                                            {paymentCycle?.isLocked && (
                                                                <Tag icon={<LockOutlined />} color="error">Locked</Tag>
                                                            )}
                                                        </div>
                                                    </Option>
                                                );
                                            })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <label htmlFor="">Collection Date <span>*</span></label>
                                <Form.Item name="collectionDate"
                                    rules={[{ required: true, message: 'Required' }]}>
                                    <DatePicker
                                        format="YYYY/MM/DD"
                                        disabledDate={(current) => current && current > moment().endOf('day')}
                                    />
                                </Form.Item>
                            </Col>
                            {paymentType === paymentTypes.fullSettlement && (
                                <Col span='24'>
                                    <Form.Item name="isDiscountApplied" valuePropName="checked">
                                        <div style={{ display: 'flex', paddingTop: '27px', gap: '8px' }}>
                                            <Checkbox />
                                            <label>Apply Discount</label>
                                        </div>
                                    </Form.Item>
                                </Col>
                            )}
                            <Row style={{ display: 'block', width: '100%' }}>
                                <div className="flex justify-end">

                                    <Button style={{ width: '170px' }} shape="round" type="primary" block htmlType="submit" loading={sendingData}>
                                        Settle User Debts
                                    </Button>
                                </div>
                            </Row>
                        </Row>
                    </Form>
                    <UserSettlementDetails
                        userInfo={userInfo}
                        paymentType={paymentType}
                        amount={amount ?? 0}
                        isDiscountApplied={isDiscountApplied}
                        selectedPaymentCycle={paymentCycleForm ?? selectedPaymentCycle}
                        fullEarlySettlement={fullEarlySettlement}
                        setFullEarlySettlement={setFullEarlySettlement}
                    />
                </Spin>
            </div >
    )
}